import '@cian/peperrors/shared';
import { SortedSource } from '../../shared/sources/sorted/SortedSource.mjs';
import { mkSetting } from '../../shared/utils/conversion.mjs';
import { SYSTEM_KEYS, SYSTEM_KEYS_ATTR_MAP, SYSTEM_KEYS_QUERY_MAP } from '../../shared/constants.mjs';

class System extends SortedSource {
    constructor(setupConfigParams) {
        const settings = [];
        // TODO: ES Modules
        if (document.currentScript) {
            const attrsParams = getParametersFromAttributes(document.currentScript);
            const urlParams = getParametersFromSrc(document.currentScript);
            const projectName = mkSetting({
                key: SYSTEM_KEYS.projectName,
                value: setupConfigParams?.settingsKey ||
                    attrsParams.projectName ||
                    urlParams?.projectName ||
                    setupConfigParams?.projectName,
                priority: 10000,
            });
            const requestId = mkSetting({
                key: SYSTEM_KEYS.requestId,
                value: attrsParams.requestId || urlParams?.requestId || setupConfigParams?.requestId,
                priority: 10000,
            });
            const versionCommit = mkSetting({
                key: SYSTEM_KEYS.versionCommit,
                value: attrsParams.versionCommit || urlParams?.versionCommit,
                priority: 10000,
            });
            if (projectName?.value) {
                settings.push(projectName);
            }
            if (requestId?.value) {
                settings.push(requestId);
            }
            if (versionCommit?.value) {
                settings.push(versionCommit);
            }
        }
        super(settings);
    }
}
function getParametersFromAttributes(scriptEl) {
    const projectName = scriptEl.dataset[SYSTEM_KEYS_ATTR_MAP.projectName];
    const requestId = scriptEl.dataset[SYSTEM_KEYS_ATTR_MAP.requestId];
    const versionCommit = scriptEl.dataset[SYSTEM_KEYS_ATTR_MAP.versionCommit];
    return { projectName, requestId, versionCommit };
}
function getParametersFromSrc(scriptEl) {
    const src = scriptEl.getAttribute('src');
    if (!src) {
        return null;
    }
    const { searchParams } = new URL(src, window.location.origin);
    const projectName = searchParams.get(SYSTEM_KEYS_QUERY_MAP.projectName);
    const requestId = searchParams.get(SYSTEM_KEYS_QUERY_MAP.requestId);
    const versionCommit = searchParams.get(SYSTEM_KEYS_QUERY_MAP.versionCommit);
    return { projectName, requestId, versionCommit };
}

export { System };
//# sourceMappingURL=system.mjs.map
